import { type ComponentProps } from 'react'
import Experiment from '@mc/experiments-react'
import { SkillsList } from 'pages/certificates/components/MarketingHubPage'
import { MCCERTS_2805_HUB_VALUE_PROP_FLAG } from '../constants'
import { useMccerts2805Variables } from '../hooks/useMccerts2805Variables'

type KeyBenefits = NonNullable<ComponentProps<typeof SkillsList>['keyBenefits']>

// Same SkillsList as control; the only change is value-prop copy from GB,
// falling back to the control keyBenefits.
const EssentialsVariant = ({ keyBenefits }: { keyBenefits: KeyBenefits }) => {
  const variables = useMccerts2805Variables()

  const variantBenefits = [
    {
      title: variables?.value_prop_1?.title || keyBenefits[0]?.title,
      description:
        variables?.value_prop_1?.subtitle || keyBenefits[0]?.description,
    },
    {
      title: variables?.value_prop_2?.title || keyBenefits[1]?.title,
      description:
        variables?.value_prop_2?.subtitle || keyBenefits[1]?.description,
    },
    {
      title: variables?.value_prop_3?.title || keyBenefits[2]?.title,
      description:
        variables?.value_prop_3?.subtitle || keyBenefits[2]?.description,
    },
    {
      title: variables?.value_prop_4?.title || keyBenefits[3]?.title,
      description:
        variables?.value_prop_4?.subtitle || keyBenefits[3]?.description,
    },
  ]

  return <SkillsList keyBenefits={variantBenefits} />
}

export const EssentialsValuePropsExp = ({
  keyBenefits,
}: {
  keyBenefits: KeyBenefits
}) => (
  <Experiment
    name={MCCERTS_2805_HUB_VALUE_PROP_FLAG}
    track={false}
    control={() => <SkillsList keyBenefits={keyBenefits} />}
    default={() => <EssentialsVariant keyBenefits={keyBenefits} />}
  />
)
